'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

const ChartInterestRateModelError = () => {
  return <ErrorDataUnavailable minHeight="328px" />
}

export default memo(ChartInterestRateModelError)
